// Provide identifiers for each of the Activity Step Types distinctively for Progress usage purposes.
export var progressStepTypes = {
  VOCABULARY_CARD: 'VOCABULARY_CARD',
  REVIEW_ONLY_STEP_TYPE: 'REVIEW_ONLY_STEP_TYPE',
  CLOZE_TYPING: 'CLOZE_TYPING',
  TYPE_THE_ANSWER: 'TYPE_THE_ANSWER',
  CLOZE_SELECT: 'CLOZE_SELECT',
  CLOZE_DRAG_AND_DROP: 'CLOZE_DRAG_AND_DROP',
  EXTENDED_SPEAKING_RECORDING_DONE: 'EXTENDED_SPEAKING_RECORDING_DONE',
  EXTENDED_WRITING: 'EXTENDED_WRITING',
  MATCHING_BY_MENU: 'MATCHING_BY_MENU',
  MATCHING_BY_TEXT: 'MATCHING_BY_TEXT',
  IMAGE_MATCHING: 'IMAGE_MATCHING',
  MULTIPLE_CHOICE_ASSESSMENT: 'MULTIPLE_CHOICE_ASSESSMENT',
  PRONUNCIATION_PHONEME: 'PRONUNCIATION_PHONEME',
  PRONUNCIATION_WORD_SENTENCE: 'PRONUNCIATION_WORD_SENTENCE',
  SENTENCE_BUILDER_SEQUENCING: 'SENTENCE_BUILDER_SEQUENCING',
  SEQUENCING_AUDIO: 'SEQUENCING_AUDIO',
  SEQUENCING_VERTICAL: 'SEQUENCING_VERTICAL',
  TRANSFORMATION: 'TRANSFORMATION',
  READ_ALOUD: 'READ_ALOUD',
  CLOZE_SPEECH: 'CLOZE_SPEECH',
  DEMONSTRATION: 'DEMONSTRATION',
  EXPLANATION: 'EXPLANATION'
};